import { render, staticRenderFns } from "./ApprovalHeadForm.vue?vue&type=template&id=474fadd5&scoped=true&"
import script from "./ApprovalHeadForm.vue?vue&type=script&lang=js&"
export * from "./ApprovalHeadForm.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalHeadForm.vue?vue&type=style&index=0&id=474fadd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474fadd5",
  null
  
)

export default component.exports